/**
 * Iter 87 — E.2 safeErrorMessage helper
 *
 * Normalise les erreurs Axios / Fetch / réseau pour éviter les UI qui affichent
 * "[object Object]" ou des messages vides quand le backend renvoie une 500
 * imprévue ou un payload non-standard.
 *
 * Ordre de priorité :
 *   1. err.response.data.detail (FastAPI standard)
 *   2. err.response.data.message
 *   3. err.response.data (si string)
 *   4. err.message (Axios network error, "Network Error", timeout, etc.)
 *   5. fallback humain
 */
export function safeErrorMessage(err, fallback = "Une erreur inattendue est survenue") {
  if (!err) return fallback;

  // Axios shape : err.response.data.{detail|message}
  const data = err?.response?.data;
  if (data) {
    if (typeof data === "string" && data.trim()) return data;
    if (typeof data.detail === "string" && data.detail.trim()) return data.detail;
    if (typeof data.message === "string" && data.message.trim()) return data.message;
    // FastAPI validation errors → array of {loc, msg, type}
    if (Array.isArray(data.detail) && data.detail.length > 0) {
      const first = data.detail[0];
      if (first?.msg) return String(first.msg);
    }
  }

  // Pur message (Network Error, timeout)
  if (typeof err.message === "string" && err.message.trim()) return err.message;

  return fallback;
}

/**
 * Helper pour logger une erreur côté client avec request_id si présent dans la
 * réponse backend (Iter 87 E.1 attache un request_id sur les 500 globaux).
 */
export function logClientError(prefix, err) {
  const requestId = err?.response?.data?.request_id || err?.response?.headers?.["x-request-id"];
  const status = err?.response?.status;
  // Console.error volontaire — debug terrain
  // eslint-disable-next-line no-console
  console.error(`[${prefix}]`, {
    status,
    requestId,
    message: safeErrorMessage(err),
    raw: err?.response?.data ?? err?.message ?? err,
  });
}
